import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const failures = ['Los tés de sobre de supermercado están procesados y han perdido sus aceites esenciales curativos.', 'Hervir las plantas por demasiado tiempo destruye las enzimas que detienen el dolor.', "Usar agua a temperatura incorrecta no logra 'romper' la celda de la planta para liberar el principio activo.", "Ignorar los 'catalizadores' (como la pimienta o el limón) que hacen que tu cuerpo absorba la medicina natural un 200% más rápido."];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhyItFailedSection() {
  return <section className="py-12 md:py-24 px-4 bg-forest-900 text-cream-100 relative" data-id="element-164">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-500/50 to-transparent" data-id="element-165"></div>

      <div className="max-w-4xl mx-auto" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-amber-400 mb-6" data-id="element-168">
            Por Qué Lo Que Has Probado No Funcionó
          </h2>
          <p className="text-cream-200/80 font-lora text-lg max-w-2xl mx-auto" data-id="element-169">
            La medicina natural no es débil, los métodos de preparación modernos
            sí lo son.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-170">
          {failures.map((text, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-4 p-6 rounded-sm bg-forest-800/50 border border-forest-700/50 hover:border-amber-500/30 transition-colors" data-id="element-171">
              <div className="mt-1 flex-shrink-0 p-1.5 rounded-full bg-red-900/30 text-red-400 border border-red-900/50" data-id="element-172">
                <X size={18} strokeWidth={2.5} data-id="element-173" />
              </div>
              <p className="font-lora text-cream-100/90 leading-relaxed" data-id="element-174">
                {text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}